<template>
  <el-empty description="V-123Chat"></el-empty>
</template>

<script setup lang="ts"></script>

<style scoped></style>
